import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  valueWithIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  statusIcon: {
    fontSize: '1.2rem',
  },
  activeIcon: {
    color: theme.palette.success.main,
  },
  inactiveIcon: {
    color: theme.palette.grey[500],
  },
  criticalityLowIcon: {
    color: theme.palette.info.main,
  },
  criticalityMediumIcon: {
    color: theme.palette.warning.main,
  },
  criticalityHighIcon: {
    color: theme.palette.error.main,
  },
  stickyMenuContainer: {
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  stickyProgress: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  completedContentBorder: {
    border: `2px solid ${theme.palette.success.main}`,
  },
}));
